import { IOverride, IPrettify } from './various';

/**
 * List of ISO 639 language codes (set 1)
 * https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
 */

export type ILetter = 'a' | 'b' | 'c' | 'd' | 'e' | 'f' | 'g' | 'h' | 'i' | 'j' | 'k' | 'l' | 'm' | 'n' | 'o' | 'p' | 'q' | 'r' | 's' | 't' | 'u' | 'v' | 'w' | 'x' | 'y' | 'z';

export type ILocaleId = `${ILetter}${ILetter}`;

export type ILocalizedString = Partial<Record<ILocaleId, string>>;

export type ILocalizable = string | ILocalizedString;

export type ILocalized<T> = IPrettify<IOverride<T, ILocalizedString, string>>;
